module.exports = __webpack_public_path__ + "img/dat08.bfcab8e2.jpg";